// @flow

export default class Permission {
    roles: ?Array<string>;
    displayName: ?string;
    email: ?string;
    uid: ?string;

    constructor(args: ?Object = {}) {
        this.uid = args.uid || null;
        this.displayName = args.displayName || null;
        this.email = args.email || null;
        this.roles = args.roles || [];
    }

    static create(args: ?Object = {}, uid?: string) {
        const _args = { ...args };
        if (Boolean(uid)) {
            _args.uid = uid;
        }
        return new Permission(_args);
    }
}